import fifthaveClient from './fifthaveClient'
import metamorphClient from './metamorphClient'

interface ImageItem {
  url: string
  width: number
  height: number
  format: string
}

export interface Image {
  full: ImageItem
  thumbnail?: ImageItem
  index?: number
}

export interface StandardProduct {
  id: string
  images: Image[]
  brandId: string
  brand: string
  categoryId: string
  category: string
  name: string
  nameCN: string
  imageScore?: number
  marketValue?: number
  aggregateComment?: boolean
  articleNumber?: string
  createdAt?: number
  lastUpdatedAt?: number
  lastUpdatedBy?: string
  totalProduct?: number
  availableProduct?: number
  marketDollar?: string
  marketRMB?: string
  attributes?: {'attributes': {'feature_ids': {'choices':[]}}}
}


export interface StarInfo {
  id: string
  created_at: number
  last_modified_at: number
  parent_id?: string
  type?: number
  valid: boolean
  value: string
  patterns?: {}
}

export const getStandardProductsList = (queryData: Record<string, any> = {}) =>
         fifthaveClient.post<{ count: number; list: StandardProduct[] }>(
           `/api/v1/_internal/standard-products/list`,
           queryData
         )

export interface StandardProductsInfo {
  images?: Image[]
  brandId: string
  brand: string
  categoryId: string
  category: string
  name: string
  nameCN: string
  articleNumber: number
  imageScore?: string
  marketValue?: string
} 
export const addStandardProducts = (data: StandardProductsInfo) =>
         fifthaveClient.post(`/api/v1/_internal/standard-products`, data)
         

export const putStandradProduct = (id: string, data: Partial<StandardProductsInfo>) =>
         fifthaveClient.put(`/api/v1/_internal/standard-product/${id}`, data)

export const deleteStandradProduct = (id: string) =>
         fifthaveClient.delete(`/api/v1/_internal/standard-product/${id}`)


export const refreshStandradProduct = (id: string) =>
         fifthaveClient.post(`/api/v1/_internal/standard-product/${id}/relations/refresh`)


export const checkProduct = (productId:string) =>
         fifthaveClient.get(`/api/v1/_internal/standard-products/check/${productId}`)

export const getStandradProductDetail = (id: string) =>
         fifthaveClient.get(`/api/v1/_internal/standard-product/${id}`)

export const getStarStyleInfoList = () =>
          metamorphClient.get(`/api/v1/_internal/attr/seye/values?f=0&t=1000`)


export interface StandradProductRelations {
  productId: string
  standardProductId: string
  auto: boolean
  productAvailable: boolean
  createdAt: number
  lastUpdatedAt: number
}

export const getStandradProductRelations = (id: string) =>
         fifthaveClient.get<StandradProductRelations[]>(
           `/api/v1/_internal/standard-product/${id}/relations`
         )

export const deleteStandradProductRelations = (id: string, pId: string) =>
         fifthaveClient.delete(`/api/v1/_internal/standard-product/${id}/relations/${pId}`)

export const addStandradProductRelations = (id: string, pId: string) =>
         fifthaveClient.post(`/api/v1/_internal/standard-product/${id}/relations/${pId}`)

export const addStandradProductsById = (productIdList: string[]) =>
         fifthaveClient.post<{
           taskId: string
         }>(`/api/v1/_internal/standard-products/batch/upload`, { productIdList })

export const getStandradProductsTasks = () =>
         fifthaveClient.get(`/api/v1/_internal/standard-products/batch/list`)